'use strict';

module.exports = /^[A-Za-z0-9_-]{4,32}$/;
